import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import { Card } from 'antd';
import styled from 'styled-components';
import DocumentUploader from 'containers/WorkOrder/DocumentUploader';
import PropTypes from 'prop-types';

const StyledCard = styled(Card)`
  & {
    width: 100%;
    min-height: 110px;
  }

  &.no-title.no-border {
    .ant-card-body {
      padding: 0;
    }
    box-shadow: none;
  }

  .title {
    margin-bottom: 12px;
  }

  .ant-card-body {
    padding: 12px 12px 24px;
  }
`;

const AddDocumentsCard = forwardRef(
  (
    {
      onFileUploaded = () => {},
      onFileRemove = () => {},
      documents = [],
      overrideUploadProps = {},
      showTitle = true,
      showBorder = true,
      maxVisibleItems = null,
      onClickFile,
    },
    ref
  ) => {
    const [documentsList, setDocumentsList] = useState([...documents]);
    const [isRefreshedDocuments, setIsRefreshedDocuments] = useState(false);

    useEffect(() => {
      setDocumentsList([...documents]);
    }, [documents]);

    useImperativeHandle(ref, () => ({
      getDocuments: () => documentsList,
      clearDocuments: () => {
        setDocumentsList([]);
        setIsRefreshedDocuments(true);
        setTimeout(() => {
          setIsRefreshedDocuments(false);
        }, 100);
      },
    }));

    const handleFileUploaded = (file, status = 'done') => {
      if (status === 'removed') {
        if (file.url) {
          setDocumentsList((prevDocs) =>
            prevDocs.filter((doc) => doc.url !== file.url)
          );
          onFileRemove(file);
          return;
        }

        onFileRemove(file);
        setDocumentsList((prevDocs) =>
          prevDocs.filter((doc) => doc.uid !== file.uid)
        );
        return;
      }

      setDocumentsList((prevDocs) => [...prevDocs, file]);
      onFileUploaded(file);
    };

    const handleFileClick = (file) => {
      if (!file.url) {
        return;
      }
      if (onClickFile) {
        return onClickFile(file);
      }
      window.open(file.url, '_blank');
    };

    return (
      <StyledCard
        bordered={false}
        className={
          !showTitle && !showBorder
            ? 'add-documents-card no-title no-border'
            : 'add-documents-card'
        }
      >
        {!isRefreshedDocuments && (
          <DocumentUploader
            showTitle={showTitle}
            maxVisibleItems={maxVisibleItems}
            wo_files={{
              wo_images: [],
              wo_documents: documentsList?.length ? documentsList : [],
            }}
            onFileUploaded={handleFileUploaded}
            overrideUploadProps={overrideUploadProps}
            onClickFile={handleFileClick}
            showScanModal={false}
          />
        )}
      </StyledCard>
    );
  }
);

AddDocumentsCard.propTypes = {
  onFileUploaded: PropTypes.func,
  onFileRemove: PropTypes.func,
  documents: PropTypes.array,
  overrideUploadProps: PropTypes.object,
  showTitle: PropTypes.bool,
  showBorder: PropTypes.bool,
  maxVisibleItems: PropTypes.number,
  onClickFile: PropTypes.func,
};

AddDocumentsCard.displayName = 'AddDocumentsCard';

export default AddDocumentsCard;
